import { takeEvery, put, call, select } from "redux-saga/effects";

import * as action from "./actions";
import * as analytics_metric_actions from "../AnalyticsMetric/actions";
import * as api from "../../apis";
import * as merchant_action from "../Merchant/actions";
import { globalFilters, getUserCapabilities, getMetric } from "./selectors";
import {
  supported_flyer_metrics,
  supported_item_metrics
} from "./components/MetricsSideMenu";
import { hasFinancePermissions } from "../AnalyticsMetric/constants";

export function* getAggregatedMetrics(request: IPayload) {
  try {
    yield put(action.setAggregateMetricsLoading(true));
    const filters = yield select(globalFilters);
    let response = yield call(api.overall_metrics, {
      ...request.payload,
      filters
    });
    yield put(action.addAggregatedMetrics(response));
    yield put(action.setAggregateMetricsLoading(false));
  } catch (e) {
    console.log(e);
    yield put(action.getAggregatedMetricsFailure());
  }
}

export function* getPublications(request: IPayload) {
  try {
    yield put(action.setPublicationsLoading(true));
    let response = yield call(api.fetchPublications, request.payload);
    yield put(action.addPublications(response));
    yield put(action.setPublicationsLoading(false));
  } catch (e) {
    console.log(e);

    if (e.response.status == 401) {
      // Going to leverage publication end point as main trigger
      yield put(action.setMerchantSelection(null));
      yield put(action.setPublicationSelection([]));
      yield put(action.setStartDate(null));
      yield put(action.setEndDate(null));
      yield put(analytics_metric_actions.setMetricContentGroupBy(null));
      yield put(analytics_metric_actions.setMetricContentCompareBy(null));
      yield put(analytics_metric_actions.setMetricContentView(null));
    }

    yield put(action.setPublicationsLoading(false));
    yield put(action.getPublicationsFailure());
  }
}

export function* watchGetPublications() {
  yield takeEvery(action.GET_PUBLICATIONS, getPublications);
}

export function* watchGetAggregatedMetrics() {
  yield takeEvery(action.GET_AGGREGATED_METRICS, getAggregatedMetrics);
}

export function* getAnalyticsMerchants(request: any) {
  try {
    let response = yield call(api.fetchAnalyticsMerchants, request.payload);
    yield put(merchant_action.addMerchants(response));
  } catch (e) {
    yield put(action.getAnalyticsMerchantsFailure());
  }
}

export function* watchGetAnalyticsMerchants() {
  yield takeEvery(action.GET_ANALYTICS_MERCHANT, getAnalyticsMerchants);
}

export function* setMetricSelection(request: IPayload) {
  try {
    const { permissions, features } = yield select(getUserCapabilities);
    const filters = yield select(globalFilters);
    let updateMetricSelection = false;
    let { metric } = request.payload;
    if (supported_flyer_metrics[metric] || supported_item_metrics[metric]) {
      updateMetricSelection = true;
      if (metric == "spend") {
        updateMetricSelection = hasFinancePermissions(
          permissions,
          request.payload.merchant_id
        );
      }
    }
    if (updateMetricSelection) {
      yield put(action.setMetricsContainerTab(request.payload.metric));
    } else {
      location.href = "/analytics";
    }
  } catch (e) {
    console.log(e);
  }
}

export function* watchSetMetricSelection() {
  yield takeEvery(action.SET_METRIC_SELECTION, setMetricSelection);
}

export function* setGlobalFilterSelection(request: IPayload) {
  try {
    const metric = yield select(getMetric);
    const hostedOnly =
      request.payload.channel.length == 1 &&
      request.payload.channel.includes("hosted");
    yield put(action.setGlobalFilters(request.payload));
    if (metric == "page_views" && !hostedOnly) {
      yield put(action.setMetricsContainerTab("impressions"));
    }
  } catch (e) {}
}

export function* watchSetGlobalFilterSelection() {
  yield takeEvery(
    action.SET_GLOBAL_FILTERS_SELECTION,
    setGlobalFilterSelection
  );
}



// WEBPACK FOOTER //
// ./client/modules/Analytics/sagas.ts